import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n'; // initialize i18next before the app mounts
import App from './App';
import { initAnalytics } from './analytics';

// xterm FitAddon triggers ResizeObserver faster than browsers can deliver
// callbacks. Two-pronged fix:
//   1. Wrap ResizeObserver in requestAnimationFrame so callbacks batch within
//      a single frame and the browser never has "undelivered notifications".
//      This eliminates the warning at the source.
//   2. Belt-and-suspenders global handler in CAPTURE phase so it fires BEFORE
//      CRA's dev-overlay listener (which is bubble phase) in case anything
//      still slips through.
if (typeof window !== 'undefined' && window.ResizeObserver) {
  const NativeRO = window.ResizeObserver;
  window.ResizeObserver = class extends NativeRO {
    constructor(callback) {
      let frame = 0;
      super((entries, observer) => {
        if (frame) cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          frame = 0;
          try { callback(entries, observer); } catch (_) { /* swallow */ }
        });
      });
    }
  };
}
window.addEventListener('error', (e) => {
  if (e.message && e.message.includes('ResizeObserver')) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
}, true);

// PostHog — no-op unless REACT_APP_POSTHOG_PROJECT_TOKEN is set. Started before
// the first render so early events (and the first pageview) aren't dropped.
initAnalytics();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
